import { Tooltip } from '@/components/tooltip.js';
import { Label } from '@/components/ui/label.js';
import { ReactNode } from '@tanstack/react-router';
import clsx from 'clsx';
import { Info } from 'lucide-react';
import React from 'react';

/**
 * A stacked key/value display widget
 * @returns
 */
export const InfoKeyValue: React.FC<{
  label: ReactNode;
  labelTooltip?: ReactNode;
  value?: React.ReactNode;
  edit?: {
    editing?: boolean;
    editModeComponent: React.ReactNode;
  };
  className?: string;
  labelClassName?: string;
  labelBold?: boolean;
  'data-testid'?: string;
}> = ({ label, value, edit, className, labelClassName, labelBold = true, 'data-testid': dataTestId, labelTooltip }) => {
  const isEditMode = edit?.editing;
  const wrapClass = 'min-w-0 [overflow-wrap:anywhere]';
  return (
    <>
      {isEditMode ? (
        edit.editModeComponent
      ) : (
        <div className={clsx('space-y-2', className)}>
          <div className="flex min-w-0 items-start gap-2">
            <Label
              className={clsx(labelBold && 'font-bold', wrapClass, '[&_*]:[overflow-wrap:anywhere]')}
              data-testid={dataTestId ? `${dataTestId}-label` : undefined}
            >
              {label}
            </Label>
            {labelTooltip && <Tooltip trigger={<Info className="h-5 w-5" />}>{labelTooltip}</Tooltip>}
          </div>
          {typeof value === 'string' ? (
            <p className={clsx(wrapClass, labelClassName)} data-testid={dataTestId ? `${dataTestId}-value` : undefined}>
              {value}
            </p>
          ) : (
            <div
              className={clsx(wrapClass, labelClassName)}
              data-testid={dataTestId ? `${dataTestId}-value` : undefined}
            >
              {value}
            </div>
          )}
        </div>
      )}
    </>
  );
};
